import React, { useState } from "react";
import Countdown from "react-countdown";
import { useQueryClient } from "react-query";
import { Timer_INIT } from "../../config/cacheKey";
import Button from "@mui/material/Button";

interface rendererPropsInterface {
    hours: any,
    minutes: any,
    seconds: any,
    completed: any
}

// Renderer callback with condition

interface CountdownCmpPropsInterface {
    onCompletedClick: any,
    countDownValue: number,
    btnName: string
}

export const NoticeCountdownCmp = ({ onCompletedClick, countDownValue, btnName }: CountdownCmpPropsInterface) => {
    const queryClient = useQueryClient();
    let timerInitFlag = queryClient.getQueryData<boolean>(Timer_INIT);
    const [timer, setTimer] = React.useState<number>(Date.now() + countDownValue)
    const [timerInit, settImerInit] = React.useState<boolean>(timerInitFlag!)
    function handleOnChildClick() {
        setTimer(Date.now() + countDownValue);
        settImerInit(true)
        onCompletedClick();
    }

    const renderer = ({ hours, minutes, seconds, completed }: rendererPropsInterface) => {
        if (completed || timerInit === false) {
            // Render a completed state
            return <Button
                disabled={false}
                className="btnForm SuccessDefault"
                style={{ minWidth: '100%' }}> <p className="cursorPointer" style={{ display: 'contents' }} onClick={handleOnChildClick}>  {btnName} </p> </Button>
        } else {
            // Render a countdown
            return <Button
                disabled={true}
                className="btnForm btnFormdisable"
                style={{ minWidth: '100%' }}> <span>{minutes}:{seconds}</span> </Button>
        }
    };

    return (<Countdown
        overtime={true}
        date={timer}
        renderer={renderer} />)
}